module.exports = __webpack_public_path__ + "static/media/28n.3e156430.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/28n.svg
// module id = 175
// module chunks = 0